<div #tableWrapper class="responsive-table-wrapper">
  <div class="table-toolbar">
    <div class="table-toolbar-actions">
      <button
        *ngIf="showRefreshButton"
        mat-raised-button
        color="action"
        class="refresh-button"
        type="button"
        matTooltip="Atualizar"
        aria-label="Atualizar dados"
        (click)="refreshRequested.emit()"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <button
        *ngIf="showColumnSelector && configurableColumns.length"
        mat-raised-button
        color="action"
        type="button"
        [matMenuTriggerFor]="columnsMenu"
        (menuOpened)="prepareColumnSelection()"
        aria-label="Configurar colunas visíveis"
      >
        <mat-icon>view_column</mat-icon>
        <span>Colunas {{ visibleColumnCount }}/{{ configurableColumns.length }}</span>
        <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
      </button>
    </div>
    <div class="table-toolbar-pagination">
      <ng-content select="mat-paginator[tablePaginator]"></ng-content>
    </div>
  </div>

  <mat-menu #columnsMenu="matMenu" class="responsive-table-column-menu">
    <div
      class="column-picker"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="column-picker-header">
        <strong>Colunas visíveis</strong>
        <span>{{ pendingVisibleColumns.size }} de {{ configurableColumns.length }}</span>
      </div>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="column-search">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [(ngModel)]="columnSearch"
          placeholder="Buscar coluna"
          aria-label="Buscar coluna"
        />
        <button
          *ngIf="columnSearch"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Limpar busca"
          (click)="columnSearch = ''"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div
        class="column-options"
        role="group"
        aria-label="Colunas disponíveis"
        cdkDropList
        [cdkDropListData]="filteredConfigurableColumns"
        [cdkDropListDisabled]="!!columnSearch"
        (cdkDropListDropped)="dropColumn($event)"
      >
        <div
          class="column-option"
          *ngFor="let column of filteredConfigurableColumns"
          cdkDrag
          [cdkDragDisabled]="!!columnSearch"
        >
          <mat-icon
            cdkDragHandle
            class="column-drag-handle"
            [matTooltip]="columnSearch ? 'Limpe a busca para ordenar' : 'Arraste para ordenar'"
          >
            drag_indicator
          </mat-icon>
          <mat-checkbox
            color="primary"
            [checked]="isColumnPending(column)"
            [disabled]="column.neverHide"
            (change)="togglePendingColumn(column, $event.checked)"
            >{{ column.header }}</mat-checkbox
          >
          <mat-icon
            *ngIf="column.neverHide"
            matTooltip="Coluna obrigatória"
            aria-label="Coluna obrigatória"
            >lock</mat-icon
          >
        </div>
        <div class="empty-columns" *ngIf="!filteredConfigurableColumns.length">
          Nenhuma coluna encontrada.
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="column-picker-actions">
        <button mat-button type="button" color="primary" (click)="resetPendingColumns()">
          Restaurar padrão
        </button>
        <button mat-raised-button type="button" color="primary" (click)="applyColumnSelection()">
          Aplicar
        </button>
      </div>
    </div>
  </mat-menu>

  <div class="bulk-toolbar" *ngIf="selection.enabled && bulkActions.length">
    <span>{{ selectedRows.length }} selecionado(s)</span>
    <button
      mat-raised-button
      type="button"
      *ngFor="let action of bulkActions"
      [color]="action.color || 'primary'"
      [disabled]="!bulkActionEnabled(action)"
      (click)="$event.stopPropagation(); executeBulkAction(action)"
    >
      <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon
      >{{ action.label }}
    </button>
  </div>
  <mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <ng-container matColumnDef="__selection" *ngIf="selection.enabled">
      <mat-header-cell *matHeaderCellDef [style.flex]="'0 0 52px'">
        <mat-checkbox
          *ngIf="selection.showHeaderCheckbox !== false"
          [checked]="isAllSelected()"
          [indeterminate]="isPartiallySelected()"
          (click)="$event.stopPropagation()"
          (change)="toggleAll()"
          aria-label="Selecionar todos"
        ></mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [style.flex]="'0 0 52px'"
        ><mat-checkbox
          [checked]="isSelected(row)"
          [disabled]="!canSelect(row)"
          (click)="$event.stopPropagation()"
          (change)="toggleRow(row)"
          aria-label="Selecionar registro"
        ></mat-checkbox
      ></mat-cell>
      <mat-footer-cell *matFooterCellDef [style.flex]="'0 0 52px'"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="__expand" *ngIf="hasExpandableRows">
      <mat-header-cell *matHeaderCellDef [style.flex]="'0 0 48px'"></mat-header-cell>
      <mat-cell *matCellDef="let row" [style.flex]="'0 0 48px'">
        <button
          mat-icon-button
          type="button"
          (click)="$event.stopPropagation(); toggleExpanded(row)"
          [attr.aria-expanded]="isExpanded(row)"
          aria-label="Exibir detalhes"
        >
          <mat-icon>{{ isExpanded(row) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef [style.flex]="'0 0 48px'"></mat-footer-cell>
    </ng-container>
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
      <mat-header-cell *matHeaderCellDef mat-sort-header [style.flex]="columnFlex(column)">{{
        column.header
      }}</mat-header-cell>
      <mat-cell *matCellDef="let row" [style.flex]="columnFlex(column)"
        ><idba-mat-table-cell [column]="column" [row]="row"></idba-mat-table-cell
      ></mat-cell>
      <mat-footer-cell *matFooterCellDef [style.flex]="columnFlex(column)">
        <idba-mat-table-footer [column]="column"></idba-mat-table-footer>
      </mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="__actions" *ngIf="rowActions.length">
      <mat-header-cell *matHeaderCellDef [style.flex]="actionColumnFlex">{{
        actionsLabel
      }}</mat-header-cell>
      <mat-cell *matCellDef="let row" [style.flex]="actionColumnFlex">
        <ng-container *ngFor="let action of rowActions">
          <button
            mat-raised-button
            type="button"
            class="row-action"
            *ngIf="visibleAction(action, row)"
            [color]="action.color || 'primary'"
            [routerLink]="action.routerLink ? action.routerLink(row) : null"
            [queryParams]="actionQueryParams(action, row)"
            [disabled]="action.disabled && action.disabled(row)"
            [matTooltip]="action.tooltip || action.label"
            (click)="$event.stopPropagation(); invokeAction(action, row)"
          >
            <mat-icon>{{ action.icon || 'more_horiz' }}</mat-icon
            ><span>{{ action.label }}</span>
          </button>
        </ng-container>
      </mat-cell>
      <mat-footer-cell *matFooterCellDef [style.flex]="actionColumnFlex"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="__detail">
      <mat-cell *matCellDef="let row" [attr.colspan]="tableColumns.length">
        <div class="detail-content" *ngIf="isExpanded(row)">
          <div class="detail-field" *ngFor="let column of hiddenColumns">
            <strong>{{ column.header }}</strong>
            <idba-mat-table-cell [column]="column" [row]="row"></idba-mat-table-cell>
          </div>
          <ng-container *ngIf="detailTemplate" [ngTemplateOutlet]="detailTemplate" [ngTemplateOutletContext]="{ $implicit: row }"></ng-container>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: tableColumns"
      [class.expandable-row]="hasExpandableRows"
      (click)="hasExpandableRows && toggleExpanded(row)"
    ></mat-row>
    <mat-footer-row *matFooterRowDef="tableColumns" [hidden]="!hasFooter"></mat-footer-row>
    <mat-row
      *matRowDef="let row; columns: detailRowColumns"
      class="detail-row"
      [class.detail-row-expanded]="isExpanded(row)"
    ></mat-row>
  </mat-table>
</div>
